import { useState } from "react";
import { Check, Minus, ChevronDown } from "lucide-react";

const COLS = ["bundle", "crypto", "stocks", "forex"];
const LABELS = { bundle: "ALL ACCESS", crypto: "CRYPTO", stocks: "STOCKS", forex: "FOREX" };

const ROWS = [
  ["Crypto & memecoin trading ideas room", ["bundle", "crypto"]],
  ["Stocks & options trading ideas room", ["bundle", "stocks"]],
  ["Forex trading ideas room", ["bundle", "forex"]],
  ["On-chain & narrative breakdowns", ["bundle", "crypto"]],
  ["Earnings & catalyst plays", ["bundle", "stocks"]],
  ["Session-based FX analysis", ["bundle", "forex"]],
  ["SynDex AI trading bot access", ["bundle", "crypto"]],
  ["Access to owner & mentors", COLS],
  ["Priority Q&A & live rooms", ["bundle"]],
];

const Cell = ({ on, featured, testId }) => (
  <td data-testid={testId} className={`py-4 px-3 text-center ${featured ? "bg-white/[0.04]" : ""}`}>
    {on ? (
      <Check size={16} className={`inline ${featured ? "text-emerald-300" : "text-white"}`} />
    ) : (
      <Minus size={16} className="inline text-white/20" />
    )}
  </td>
);

export const CompareTable = ({ plans, billing }) => {
  const byId = Object.fromEntries(plans.map((p) => [p.id, p[billing]]));
  const suffix = billing === "monthly" ? "/mo" : "/yr";
  const [open, setOpen] = useState(false);

  return (
    <div className="max-w-6xl mx-auto mt-20" data-testid="compare-table-section">
      <div className="text-center">
        <p className="font-mono-serif text-[10px] tracking-[0.4em] text-white/45">COMPARE // PLANS</p>
        <h2 className="mt-3 font-display text-3xl md:text-5xl">Why All Access wins</h2>
        <button
          data-testid="compare-toggle-btn"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          className="mt-6 inline-flex items-center gap-2 border border-white/20 text-white font-mono-serif text-[11px] tracking-[0.3em] px-6 py-3.5 rounded-full hover:bg-white/5 transition-colors"
        >
          {open ? "HIDE COMPARISON" : "COMPARE PLANS"}
          <ChevronDown size={14} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </button>
      </div>

      <div
        data-testid="compare-collapsible"
        className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
      >
      <div className="overflow-hidden">

      <div className="mt-10 frame overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm" data-testid="compare-table">
          <thead>
            <tr className="border-b border-white/10">
              <th className="py-5 px-5 text-left font-mono-serif text-[10px] tracking-[0.3em] text-white/45">FEATURE</th>
              {COLS.map((id) => (
                <th
                  key={id}
                  className={`py-5 px-3 font-mono-serif text-[10px] tracking-[0.3em] ${
                    id === "bundle" ? "bg-white/[0.04] text-white" : "text-white/60"
                  }`}
                >
                  {LABELS[id]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, has], i) => (
              <tr key={label} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                <td className="py-4 px-5 text-white/75">{label}</td>
                {COLS.map((id) => (
                  <Cell key={id} on={has.includes(id)} featured={id === "bundle"} testId={`compare-cell-${i}-${id}`} />
                ))}
              </tr>
            ))}
            <tr>
              <td className="py-5 px-5 font-mono-serif text-[10px] tracking-[0.3em] text-white/45">PRICE</td>
              {COLS.map((id) => (
                <td
                  key={id}
                  data-testid={`compare-price-${id}`}
                  className={`py-5 px-3 text-center font-display text-2xl ${id === "bundle" ? "bg-white/[0.04]" : "text-white/70"}`}
                >
                  £{byId[id].price}
                  <span className="text-xs text-white/40">{suffix}</span>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      </div>
      </div>
    </div>
  );
};
